<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="arkCode" label="客户名称/代码:" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value.trim="editForm.arkCode" placeholder="请选择" />
      </a-form-item>
      <a-form-item name="arkCode" label="成交额(万/RMB):" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value.trim="editForm.arkCode" placeholder="请选择" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { customerCodeAdd, customerCodeEdit } from '@/api/overseasSales/customerCenter'
import type { FormInstance } from 'ant-design-vue'
import { CustomerCode } from '@/typings/api/customerCenter'
import { message } from '@dc-platform/dc-components'

export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<CustomerCode>({})
const emit = defineEmits(['success'])
const toggle = (row?: CustomerCode) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}

const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const { arkCode, cosId } = editForm.value
    const p = {
      arkCode,
      cosId
    }
    try {
      if (editForm.value.id) {
        await customerCodeEdit({ ...p, id: editForm.value.id })
      } else {
        await customerCodeAdd(p)
      }
      toggle()
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      message.success(editForm.value?.id ? '编辑成功' : '新增成功')
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
